import { useForm } from "react-hook-form";

import { CircularProgress, InputAdornment } from "@mui/material";

import { TextInput } from "@components/Forms/ControlledInputs";
import useHotKey from "@utils/useHotKey";

import { useCurrentOrderSet } from "../orderSet/data/CurrentOrderSetContext";
import useUpdateOrderSetMutation from "../orderSet/data/mutations/useUpdateOrderSetMutation";

const DistributorPurchaseOrderNumberInput = () => {
  const { orderSet } = useCurrentOrderSet();
  const updateOrderSet = useUpdateOrderSetMutation();
  const { control, handleSubmit } = useForm({
    defaultValues: {
      poNumber: orderSet.distributorPurchaseOrderNumber ?? "",
    },
  });
  const handleBlur = ({ poNumber }) => {
    if ((orderSet.distributorPurchaseOrderNumber ?? "") !== poNumber) {
      updateOrderSet.mutate({
        id: orderSet.id,
        distributorPurchaseOrderNumber: poNumber.trim() || null,
      });
    }
  };

  useHotKey("Enter", () => handleSubmit(handleBlur)());

  return (
    <TextInput
      control={control}
      label="Purchase Order #"
      fullWidth
      slotProps={{
        input: {
          endAdornment: (
            <InputAdornment position="end">
              {updateOrderSet.isPending && <CircularProgress size={16} />}
            </InputAdornment>
          ),
        },
      }}
      placeholder="Add a PO #"
      name="poNumber"
      onBlur={handleSubmit(handleBlur)}
      disabled={updateOrderSet.isPending}
    />
  );
};

export default DistributorPurchaseOrderNumberInput;
